import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

// Data imports
import processorItems from "../../../data/processorItems";

// redux imports
import {
  getProcessors,
  updateProcessor,
  deleteProcessor,
} from "../../../redux/actions/processorsActions";

// Components imports
import InputField from "../../common/InputField";
import Button from "../../common/Button";

// Icons imports

import { AiOutlinePlus } from "react-icons/ai";
import { RiDeleteBin5Line } from "react-icons/ri";

// Scss imports
import css from "./ProcessorItem.module.scss";
interface ProcessorItemProps {
  number: number;
  nameText?: string;
  onNameTextInputValueChange?: Function;
  inputNameTextError?: string;
  icon: any;
  deleteIcon: boolean;
  deleteProcessorFunction?: any;
  id?: string;
  sendData: any;
  handleChange: any;
  firstName?: string;
  lastName?: string;
  nationalId?: string;
  phone?: string;
  newItem?: boolean;
  setIsClicked?: any;
  processor?: any;
  showAllProcessors?: boolean;
}

const ProcessorItem: React.FC<ProcessorItemProps> = ({
  number,
  nameText,
  onNameTextInputValueChange,
  inputNameTextError,
  nationalId,
  phone,
  lastName,
  firstName,
  icon,
  deleteIcon,
  deleteProcessorFunction,
  id,
  sendData,
  handleChange,
  newItem,
  setIsClicked,
  processor,
  showAllProcessors,
}) => {
  const dispatch = useDispatch();
  const addProcessorError = useSelector(
    (state: any) => state.allProcessors.addProcessorError
  );

  useEffect(() => {
    if (newItem === false) {
      const elementFirstName: any = document.getElementById(
        processor.id + processor.firstName
      );
      elementFirstName.value = processor.firstName;

      const elementLastName: any = document.getElementById(
        processor.id + processor.lastName
      );
      elementLastName.value = processor.lastName;

      const elementNationalId: any = document.getElementById(
        processor.id + processor.nationalId
      );
      //elementNationalId.value = processor.nationalId;

      const elementPhoneNumber: any = document.getElementById(
        processor.id + processor.phoneNumber
      );
      elementPhoneNumber.value = processor.phoneNumber;
    }
  }, []);

  const clean = (obj) => {
    for (var propName in obj) {
      if (
        obj[propName] === "" ||
        //obj[propName] === 0 ||
        obj[propName] === null ||
        obj[propName] === undefined
      ) {
        delete obj[propName];
      }
    }
    return obj;
  };

  // Set processor to inactive
  const makeProcessorInactive = (id) => {
    dispatch(
      updateProcessor(
        clean({
          active: false,
        }),
        id
      )
    );
  };

  return (
    <>
      <div className={css.container}>
        {newItem && <p className={css.errorText}>{addProcessorError}</p>}
        <div className={css.item} data-id={id}>
          <p className={css.number}>{number}</p>

          {/* Form */}
          <form className={css.form} data-id={id}>
            <InputField
              label="Име"
              name="firstName"
              id={!newItem ? processor.id + processor.firstName : "firstName"}
              type="text"
              //placeholder={newItem === false ? processor.firstName : ""}
              value={firstName}
              handleChange={handleChange}
              handleOnFocus={(e: any) => (e.target.placeholder = "")}
              handleOnBlur={(e: any) =>
                (e.target.placeholder =
                  newItem === false ? processor.firstName : "")
              }
              rowFormGroup={true}
              //onInputHandler={onInputName}
              labelClass="marginLabel"
              rowFormGroupCenter={true}
              //onClick={setIsClicked(true)}
              inputType="processor"
            />

            <InputField
              label="Презиме"
              name="lastName"
              id={!newItem ? processor.id + processor.lastName : "lastName"}
              type="text"
              //placeholder={newItem === false ? processor.lastName : ""}
              value={lastName}
              handleChange={handleChange}
              handleOnFocus={(e: any) => (e.target.placeholder = "")}
              handleOnBlur={(e: any) =>
                (e.target.placeholder =
                  newItem === false ? processor.lastName : "")
              }
              rowFormGroup={true}
              //onInputHandler={onInputSurname}
              labelClass="marginLabel"
              rowFormGroupCenter={true}
              inputType="processor"
            />
            {/*<InputField
              label="ЈМБГ"
              name="nationalId"
              id={!newItem ? processor.id + processor.nationalId : "nationalId"}
              type="text"
              //placeholder={newItem === false ? processor.nationalId : ""}
              value={nationalId}
              handleChange={handleChange}
              handleOnFocus={(e: any) => (e.target.placeholder = "")}
              handleOnBlur={(e: any) =>
                (e.target.placeholder =
                  newItem === false ? processor.nationalId : "")
              }
              rowFormGroup={true}
              //errorText={errorNationalIdText}
              //onInputHandler={onInputNationalId}
              labelClass="marginLabel"
              rowFormGroupCenter={true}
              inputType="processor"
            />
            <InputField
              label="Tелефон"
              name="phone"
              id={
                !newItem ? processor.id + processor.phoneNumber : "phoneNumber"
              }
              type="text"
              //placeholder={newItem === false ? processor.phoneNumber : ""}
              value={phone}
              handleChange={handleChange}
              handleOnFocus={(e: any) => (e.target.placeholder = "")}
              handleOnBlur={(e: any) =>
                (e.target.placeholder =
                  newItem === false ? processor.phoneNumber : "")
              }
              rowFormGroup={true}
              //errorText={errorPhoneNumberText}
              //onInputHandler={onInputPhoneNumber}
              labelClass="marginLabel"
              rowFormGroupCenter={true}
              inputType="processor"
            />*/}

            {/* Save/edit and delete buttons */}
            {!showAllProcessors && (
              <Button
                icon={icon}
                onButtonClickHandler={sendData}
                style={{
                  borderRadius: "5rem",
                  marginLeft: "2rem",
                  maxHeight: "6rem",
                }}
                //refButton={refPrevButton}
                //disabledButton={disabledPrevButton}
                //hidden={hiddenPrev}
              />
            )}
            {deleteIcon && !showAllProcessors && (
              <Button
                icon={<RiDeleteBin5Line color="#982d8f" fontSize="2.3rem" />}
                onButtonClickHandler={() => makeProcessorInactive(id)}
                style={{
                  borderRadius: "5rem",
                  marginLeft: "2rem",
                  maxHeight: "6rem",
                }}
                //refButton={refPrevButton}
                //disabledButton={disabledPrevButton}
                //hidden={hiddenPrev}
              />
            )}
          </form>
        </div>
      </div>
    </>
  );
};

export default ProcessorItem;
